"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dimensions_1 = require("../_commons/dimensions");
var CoreFunnelChart_1 = require("./CoreFunnelChart");
var withChart_1 = require("../_base/withChart");
//
// Internals
//
var funnelChartDefinition = {
    chartName: "FunnelChart",
    bucketPropsKeys: ["measures", "viewBy", "filters", "sortBy"],
    bucketsFactory: function (props) {
        return [
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.MEASURES], props.measures)),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.VIEW, props.viewBy),
        ];
    },
    executionFactory: function (props, buckets) {
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        return backend
            .withTelemetry("FunnelChart", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters)
            .withDimensions(dimensions_1.roundChartDimensions)
            .withExecConfig(execConfig);
    },
};
var WrappedFunnelChart = withChart_1.withChart(funnelChartDefinition)(CoreFunnelChart_1.CoreFunnelChart);
/**
 * A funnel chart displays values as progressively decreasing proportions.
 *
 * @remarks
 * You can define funnel chart using either multiple measures or single measure and a viewBy attribute whose
 * values will be used to slice the single measure.
 *
 * In either case, the measure values will be charted into a funnel. With the largest values being on the broadest
 * part of the funnel, and the smallest values towards the narrow part of the funnel.
 *
 * See {@link IFunnelChartProps} to learn how to configure the FunnelChart.
 *
 * @public
 */
exports.FunnelChart = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.measures, props.viewBy, props.filters, props.sortBy], props.placeholdersResolutionContext), measures = _a[0], viewBy = _a[1], filters = _a[2], sortBy = _a[3];
    return (react_1.default.createElement(WrappedFunnelChart, tslib_1.__assign({}, props, {
        measures: measures,
        viewBy: viewBy,
        filters: filters,
        sortBy: sortBy,
    })));
};
//# sourceMappingURL=FunnelChart.js.map